import React from 'react';
import { get, map, find, size, noop, isEmpty } from 'lodash';

// Local Dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';
import { widgetNoData as WidgetNoData } from 'ui/views/widgets/widgetNoData';
import classnames from 'classnames';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberAllergiesInfo as MemberAllergiesInfo } from 'ui/views/widgets/memberAllergiesInfo';
 *
 * // render
 * <MemberAllergiesInfo propName='propValue'/>
 */
export const memberAllergiesInfoSuccess = ( props ) => {

    // extracting edit Action
    const editAction = find( props.action, { name: 'edit' } );

    const { visibility = {} } = props;
    const checjMessgae=  props.memberData.isAllergiesNotAtVerified?'No yet verified':'Patient has no known drug allergies';
    
    // const { showCustomErrorView = false, description, noDataView } = props;

    // if( 0 === size( props.data ) || showCustomErrorView ) {
    // 	return (
    // 		<div className="ui-member-allergy-info-default">
    // 			<WidgetNoData />
    // 	    </div>
    // 	);
    // }

    // check action visibility
    const isEditActionActive = ! isEmpty( editAction ) ? get( visibility, `${editAction.visibility}`, false ): false;

    const actionClassName = classnames( 'ui-member-allergies-info__edit__button', {
        'ui-member-allergies-info__edit__button--disabled': ! isEditActionActive
    } );

    return (
        <div className='ui-member-allergies-info'>

            {/* action */}
            <div className='ui-member-allergies-info__edit' >
                <div className={ actionClassName }  onClick={ () => isEditActionActive ? props.onClickEdit( { action: editAction } ) : noop }>
                    <div className='ui-member-allergies-info__edit__button__icon'> <Icon name='edit' fill={ isEditActionActive ? THEME.themeColorPrimary2 : '#7a7a7a' }  /> </div>
                    <div className='ui-member-allergies-info__edit__button__title'>{ getLabel( get( editAction, 'title', {} ) ) }</div>
                </div>
            </div>

            {/* data */}
            {
            
            //    let message= props.memberData.isAllergiesNotAtVerified?'':get( props.noDataView, 'message', null );
                0 === size( props.data ) ? (
                    <div className='ui-member-allergies-info__no-data'>
                        <WidgetNoData
                            message={ props.memberData.isAllergiesNotAtVerified? get( props.noDataView, 'message2', null ): get( props.noDataView, 'message', null ) }
                            />
                            {/* { checjMessgae } */}
                    </div>
                ) : (
                    <div className='ui-member-allergies-info__allergies'>
                        { map( ( props.data ), field => {
                            return (
                                <div key={ field.id } className='ui-member-allergies-info__allergies__allergy'> { field.name } </div>
                            );
                        } ) }
                    </div>
                )
            }
        </div>
    );
};

// set display name
memberAllergiesInfoSuccess.displayName = 'memberAllergiesInfoSuccess';

// set default props
memberAllergiesInfoSuccess.defaultProps = {};

// prop types
memberAllergiesInfoSuccess.propTypes = {};

/*************************** */

//  preloader view
export const memberAllergiesInfoPreloader = ( ) => {
    return (
         <div className='ui-member-allergies-info-preloader'>
         {
             map( [ 1, 2, 3, 4, 5 ], item => {
                 return (
                     <div key={ item } className='ui-member-allergies-info-preloader__item'/>
                 );
             } )
         }
     </div>
    );
};

// set display name
memberAllergiesInfoPreloader.displayName = 'memberAllergiesInfoPreloader';

// set default props
memberAllergiesInfoPreloader.defaultProps = {};

// prop types
memberAllergiesInfoPreloader.propTypes = {};

export const memberAllergiesInfo = withNetworkState( memberAllergiesInfoPreloader, memberAllergiesInfoSuccess );
